import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { BlogPost } from '../domain';
import { PostPreviewComponent } from '../ui-post-preview/post-preview.component';
import { PostSkeletonComponent } from '../ui-post-skeleton/post-skeleton.component';

@UntilDestroy()
@Component({
  selector: 'rma-blog-post-list',
  templateUrl: './post-list.component.html',
  styleUrls: ['./post-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PostPreviewComponent, PostSkeletonComponent, MatButtonModule, RmaIconComponent, AsyncPipe],
})
export class PostListComponent implements OnInit, OnChanges {
  @Input()
  public posts: BlogPost[] | null = [];
  @Input()
  public showMore: boolean | null = false;
  @Input()
  public showPrimary: boolean | null = false;

  @Output()
  public loadMore = new EventEmitter<void>();

  public isLoading$: Observable<boolean>;
  public primaryPost: BlogPost | undefined;
  public featuredPosts: BlogPost[] = [];
  public normalPosts: BlogPost[] = [];

  private loading = new BehaviorSubject<boolean>(false);

  public ngOnInit(): void {
    this.isLoading$ = this.loading.asObservable().pipe(distinctUntilChanged());
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.posts?.currentValue) {
      this.loading.next(false);

      const posts = changes.posts.currentValue;

      if (this.showPrimary) {
        this.primaryPost = posts[0];
      }

      const offset = this.primaryPost ? 1 : 0;
      const secondaryCount = 2;

      this.featuredPosts = posts.slice(offset, secondaryCount + offset);
      this.normalPosts = posts.slice(secondaryCount + offset);
    }
  }

  public handleLoadMore(): void {
    this.loading.next(true);
    this.loadMore.emit();
  }
}
